// Port of api/fuel/app/classes/insights/hindex/concentration.php
import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'

export default Segment.extend({
    name: 'concentration',
    priority: 1,
    default_: true,
    requires: ['init'],
    insight: false,
    detail: false,
    types: [Constants.TYPE_USER, Constants.TYPE_GROUP, Constants.TYPE_BUDDIES],
    run: function(type, owner, userIndex, detail, filter, vars) {

        if (!this._data.track || !this._data.track.get_hindex()) return {}

        var concentration = []
        for (var c = 0; c <= 5; c++) concentration.push({ own: 0, all: 0 })

        var ownRows = Util.query(
            'SELECT track_concentration FROM hindex_track WHERE hindex_id = ' + this._data.type.get_id() +
            ' AND track_hindex = ' + this._data.current.get_hindex()
        )

        var values = []
        for (var i = 0; i < ownRows.length; i++) {
            values.push(parseFloat(ownRows[i].track_concentration))
        }

        for (var j = 0; j < values.length; j++) {
            var v = values[j]
            if (v < 20) concentration[0].own++
            else if (v < 40) concentration[1].own++
            else if (v < 60) concentration[2].own++
            else if (v < 75) concentration[3].own++
            else if (v < 90) concentration[4].own++
            else concentration[5].own++
        }

        if (values.length) {
            for (var k = 0; k <= 5; k++) {
                concentration[k].own = Math.round(((100 / values.length) * concentration[k].own) * 100) / 100
            }
        }

        var allRows = Util.query(
            'SELECT track_concentration FROM hindex_track WHERE hindex_id = ' + this._data.type.get_id() +
            ' AND track_hindex > 0'
        )

        var allValues = []
        for (var ai = 0; ai < allRows.length; ai++) {
            allValues.push(parseFloat(allRows[ai].track_concentration))
        }

        for (var aj = 0; aj < allValues.length; aj++) {
            var av = allValues[aj]
            if (av < 20) concentration[0].all++
            else if (av < 40) concentration[1].all++
            else if (av < 60) concentration[2].all++
            else if (av < 75) concentration[3].all++
            else if (av < 90) concentration[4].all++
            else concentration[5].all++
        }

        if (allValues.length) {
            for (var ak = 0; ak <= 5; ak++) {
                concentration[ak].all = Math.round(((100 / allValues.length) * concentration[ak].all) * 100) / 100
            }
        }

        return {
            concentration: concentration
        }

    }
})
